export default __webpack_public_path__ + "static/stories-9aedb95dedb56fe23b3db5f14233a177.png";